import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import HeatmapTable from 'components/Heatmap'
import Select from 'components/Inputs/Select'
import DateInput from 'components/Inputs/DateInput'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { DateTime } from 'luxon'

import {
  Column,
  LoadingContainer,
  FilterContainer,
  InfoText
} from '../styles'

export default function Heatmap () {
  const token = AuthService.getToken ()
  const [loadingData, setLoadingData] = useState (true)
  const [loadingHeatMap, setLoadingHeatMap] = useState (true)
  const [businesses, setBusinesses] = useState ([])
  const [selectedBusiness, setSelectedBusiness] = useState ({
    label: 'Todos os salões', value: 'all_businesses'
  })
  const [heatMapData, setHeatMapData] = useState (null)
  const [dateRange, setDateRange] = useState ([
    DateTime.now ().minus ({ days: 7 }).toISODate (),
    DateTime.now ().toISODate ()
  ])

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }
  
  useEffect (() => {
    getData ()
  }, [])

  useEffect (() => {
    if (dateRange && selectedBusiness) getHeatMap ()
  }, [dateRange, selectedBusiness])

  const getData = async () => {
    try {
      const { data: businesses } = await cutileiApi.get (
        '/businesses?status=active&page=1&per_page=99999',
        requestConfig
      )

      const businessesOptions = [
        { label: 'Todos os salões', value: 'all_businesses' },
        ...businesses.data.map (business => ({
          label: business.name,
          value: business.id
        }))
      ]

      setBusinesses (businessesOptions)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoadingData (false)
    }
  }

  const getHeatMap = async () => {
    setLoadingHeatMap (true)
    try {
      const startDate = dateRange[0]
      const endDate = dateRange[1]
      let filters = `start_date=${startDate}&end_date=${endDate}`

      if (selectedBusiness.value !== 'all_businesses')
        filters += `&business_id=${selectedBusiness.value}`

      const { data: heatMapData } = await cutileiApi.get (
        `/admin/dashboard/heat_map?${filters}`, requestConfig
      )

      setHeatMapData (heatMapData)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoadingHeatMap (false)
    }
  }

  return loadingData ? <Loading/> : (
    <Column>
      <FilterContainer style={{marginBottom: 15}}>
        <DateInput
          value={dateRange}
          selectRange={true}
          minRangeDays={7}
          maxRangeDays={31}
          onChange={setDateRange}
          style={{width: 250}}
        />
        <Select
          placeholder='Salão...'
          value={selectedBusiness}
          options={businesses}
          onChange={(_, option) => setSelectedBusiness (option)}
          containerStyles={{width: 250}}
        />
      </FilterContainer>
      {loadingHeatMap ? (
        <LoadingContainer>
          <Loading/>
          <InfoText>Gerando mapa de calor...</InfoText>
        </LoadingContainer>
      ) : (
        <HeatmapTable data={heatMapData}/>
      )}
    </Column>
  )
}
